export const GET_CUSTOMER_REQUEST = "GET_CUSTOMER_REQUEST";
export const GET_CUSTOMER_RECEIVE_DATA = "GET_CUSTOMER_RECEIVE_DATA";
export const GET_CUSTOMER_REQUEST_FAILED = "GET_CUSTOMER_REQUEST_FAILED";

export const getCustomerRequest = (id) => ({ type: GET_CUSTOMER_REQUEST, payload: id });
export const receiveData = (data) => ({ type: GET_CUSTOMER_RECEIVE_DATA, payload: data });
export const requestFailed = (error) => ({ type: GET_CUSTOMER_REQUEST_FAILED, payload: error });
